import Icon from 'veui/components/Icon'

Icon.register({
  'data-file-x': {
    paths: [
      {
        fill: '#298ef2',
        opacity: '.1',
        d: 'M28.67 26c0 1.47-5.67 2.67-12.67 2.67S3.33 27.47 3.33 26 9 23.33 16 23.33s12.67 1.2 12.67 2.67z'
      },
      {
        fill: '#e8f3ff',
        stroke: '#b3cfee',
        'stroke-width': '.67',
        d: 'M6.67 4.33C5.75 4.33 5 5.08 5 6v17.33c0 .92.75 1.67 1.67 1.67H20c.92 0 1.67-.75 1.67-1.67V6c0-.92-.75-1.67-1.67-1.67H6.67z'
      },
      {
        fill: '#fefefe',
        d: 'M26.14 8.05l-4.97-4.9c-.17-.15-.39-.48-.63-.48H8.99c-.91 0-1.66.7-1.66 1.54V23.8c0 .85.75 1.54 1.66 1.54h16.02c.91 0 1.66-.7 1.66-1.54L26.5 8.4c0-.24-.19-.19-.36-.34z'
      },
      {
        fill: 'none',
        stroke: '#b3cfee',
        'stroke-width': '.67',
        d: 'M26.16 8.16h-.01l-5.2-5a.6.6 0 00-.41-.16H8.99a1.3 1.3 0 00-1.32 1.26V24.4c0 .69.59 1.26 1.32 1.26h16.02a1.3 1.3 0 001.32-1.26V8.55a.52.52 0 00-.17-.39z'
      },
      {
        fill: 'none',
        stroke: '#b3cfee',
        'stroke-width': '.67',
        d: 'M20.67 3.33v3.83c0 .83.78 1.5 1.73 1.5h4.27'
      },
      {
        fill: '#ffa3a3',
        opacity: '.6',
        stroke: '#f58a81',
        'stroke-width': '.67',
        d: 'M13.9 13.7l1.64 1.63-1.64 1.64a.8.8 0 001.13 1.13l1.64-1.64 1.63 1.64a.8.8 0 001.13-1.13l-1.63-1.64 1.63-1.63a.8.8 0 00-1.13-1.13l-1.63 1.63-1.64-1.63a.8.8 0 00-1.13 1.13z'
      }
    ],
    width: '32',
    height: '32'
  }
})
